<template>
    <section class="section section-home-brief">
        <div class="container" @mouseleave="showIconsAnimation = false">
            <div class="row justify-content-center" @mouseover="showIconsAnimation = true">
                <div class="col-lg-12 text-center">
                    <h4 class="display-4">Data + Intellgence + Platform</h4>
                    <h1 class="display-2">One Stop AI Solution</h1>
                    <p class="lead">
                      Magicom is an AI-as-a-service (AaaS) service company, providing full-stack intellegence services and solutions ranging from data process (collection, clean, augmentation and annotation), model development (training and deployment), and enterprise applications.</p>
                </div>
                <div class="col-lg-4 col-md-6">
                  <h5 class="text-primary text-uppercase text-center" style="margin:10px 0">Data Process</h5>
                  <card class="border-0" body-classes="py-5" style="background-image:url('img/data_process.png');opacity: 1; 
                  height: 200px; background-size: cover; -moz-background-size: cover; background-position: center;">
                  </card>
                </div>

                <div class="col-lg-4 col-md-6">
                  <h5 class="text-primary text-uppercase text-center" style="margin:10px 0">Model Development</h5>
                  <card class="border-0" body-classes="py-5" style="background-image:url('img/model_development.png');opacity: 1; 
                  height: 200px; background-size: cover; -moz-background-size: cover; background-position: center;">
                  </card>
                </div>

                <div class="col-lg-4 col-md-6">
                  <h5 class="text-primary text-uppercase text-center" style="margin:10px 0">Enterprise Applications</h5>
                  <card class="border-0" body-classes="py-5" style="background-image:url('img/enterprise_application.png');opacity: 1; 
                  height: 200px; background-size: cover; -moz-background-size: cover; background-position: center;">
                  </card>
                </div> 
            </div>
        </div>
    </section>
</template>
<script>
export default {
  data() {
    return {
      
    };
  },
  methods: {
  }
};
</script>
<style>
</style>
